import { Rive } from '@rive-app/canvas'

export default function initRive() {
  const logo = document.getElementById('js--canvas-logo')

  if (!logo) return

  const r = new Rive({
    src: '/wp-content/themes/jersey-opera-house/dist/img/rive/logo.riv',
    canvas: logo,
    autoplay: true,
    stateMachines: 'state',
    onLoad: () => {
      r.resizeDrawingSurfaceToCanvas()
    },
  })
}
